var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKanBanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.125V5.375H5.95833V0.5H1.625C0.729083 0.5 0 1.22908 0 2.125ZM7.04167 13.5H11.375C12.2709 13.5 13 12.7709 13 11.875V8.625H7.04167V13.5ZM11.375 0.5H7.04167V7.54167H13V2.125C13 1.22908 12.2709 0.5 11.375 0.5ZM0 11.875C0 12.7709 0.729083 13.5 1.625 13.5H5.95833V6.45833H0V11.875Z",
    fill: "#586370"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanBanIcon);
export default __webpack_public_path__ + "static/media/kanBanIcon.d3d83d5f564281638aa5b8e87a76aab5.svg";
export { ForwardRef as ReactComponent };